import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import FindCreators from './pages/FindCreators';
import Pricing from './pages/Pricing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import Services from './pages/Services';
import BrandDashboard from './pages/BrandDashboard';
import CreatorDashboard from './pages/CreatorDashboard';
import CreateCampaign from './pages/CreateCampaign';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import DataDeletion from './pages/DataDeletion';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import ForgotPassword from './pages/ForgotPassword';
import InvitationAction from './pages/InvitationAction';
import InvitationError from './pages/InvitationError';
import PerformanceHub from './pages/PerformanceHub';
import PerformanceConnect from './pages/PerformanceConnect';
import ScrollToTop from './components/ScrollToTop';
import PosthogAnalytics from './analytics/PosthogAnalytics';
import { MILAN_WORKSPACE_ENABLED } from './config/productFlags';
import './App.css';

/** Campaign routes → Performance Hub when Milan Workspace is disabled. */
function WorkspaceOrRedirect({ children }) {
  if (!MILAN_WORKSPACE_ENABLED) {
    return <Navigate to="/performance" replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <PosthogAnalytics />
      <div className="app-root">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/find-creators"
          element={
            <WorkspaceOrRedirect>
              <FindCreators />
            </WorkspaceOrRedirect>
          }
        />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources" element={<Resources />} />
        <Route
          path="/brand-dashboard"
          element={
            <WorkspaceOrRedirect>
              <BrandDashboard />
            </WorkspaceOrRedirect>
          }
        />
        <Route path="/performance" element={<PerformanceHub />} />
        <Route path="/performance/connect" element={<PerformanceConnect />} />
        <Route path="/creator-dashboard" element={<CreatorDashboard />} />
        <Route
          path="/dashboard"
          element={
            MILAN_WORKSPACE_ENABLED ? (
              <BrandDashboard />
            ) : (
              <Navigate to="/performance" replace />
            )
          }
        />
        <Route
          path="/create-campaign"
          element={
            <WorkspaceOrRedirect>
              <CreateCampaign />
            </WorkspaceOrRedirect>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
        <Route path="/about" element={<Navigate to="/" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* Invitation action pages (accept/reject from email) — keep for legacy links */}
        <Route path="/invitation/:action" element={<InvitationAction />} />
        <Route path="/invitation-error" element={<InvitationError />} />
        <Route
          path="/campaign/:id"
          element={
            <Navigate
              to={MILAN_WORKSPACE_ENABLED ? '/brand-dashboard?tab=live' : '/performance'}
              replace
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
